import React from "react";

import { SvgIcon } from "@mui/material/";

const Close = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 96 960 960">
      <path d="M287 812.308 245.692 769l192-193-192-195L287 337.692l194 195 192-195L714.308 381l-192 195 192 193L673 812.308l-192-195-194 195Z" />
    </SvgIcon>
  );
};

export default Close;
